import ShowMoreElements from "./showMore";

export const showMoreElements = {
    init: () => {
        const showMoreContainer = document.querySelectorAll(".sd-show-more");
        const showMoreButton = document.getElementById("sd-show-more-button");
        [...showMoreContainer].forEach(() => new ShowMoreElements(showMoreContainer, showMoreButton));
    }
}

export default showMoreElements;